import { render, staticRenderFns } from "./InicioDos.vue?vue&type=template&id=1eccefe8&scoped=true"
import script from "./InicioDos.vue?vue&type=script&lang=js"
export * from "./InicioDos.vue?vue&type=script&lang=js"
import style0 from "./InicioDos.vue?vue&type=style&index=0&id=1eccefe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eccefe8",
  null
  
)

export default component.exports